import { render, staticRenderFns } from "./TableSorter.vue?vue&type=template&id=51cf83e1"
import script from "./TableSorter.vue?vue&type=script&lang=js"
export * from "./TableSorter.vue?vue&type=script&lang=js"
import style0 from "./TableSorter.vue?vue&type=style&index=0&id=51cf83e1&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports